import { action } from 'easy-peasy';
import { IActionSetCrisisCallTeamMembers } from '../types';

const setCrisisCallTeamMembers: IActionSetCrisisCallTeamMembers = action((state, payload) => {
  state.crisisCallTeamMembers = payload;
});

export default setCrisisCallTeamMembers;
